const tasksTypes = [
  {
    value: 4,
    label: 'Make an appointment',
  },
];

export { tasksTypes };
